import { useRef , useState } from 'react'

//firebase
import { cloudStorage } from '../../api/firebase'
import { getDownloadURL, ref, uploadBytesResumable } from '@firebase/storage' 

//icon import 
import { FaPlusCircle } from 'react-icons/fa'
import styled from 'styled-components'
const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 100%;
    h3{
        width: 100%;
        flex: 0.8;
        text-align: center;
    }

    span {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .preview__container { 
        position: relative;
        max-width: 200px;
        max-height: 200px;
    }

    .overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100%;
        width: 100%;
        opacity: 0;
        z-index: 20;
        transition: all 0.5s ease-in;
        background-color: rgba(0,0,0,0.6);
    }
    .preview__container:hover .overlay{
        opacity: 1;
    }

    .content{
        color: white;
        font-size: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
    }



    .preview__container img {
        z-index: 1;
        position: relative;
        bottom: 0; left: 0%;
        width: 100%;
        height: 100%;
        border-radius: 5px;
        box-shadow: 1px 1px 4px rgb( 0 , 0 , 0 , 0.4);

    }

    #icon:hover{
        color: aquamarine;
    }

`




const ImageUploader = ({ urlSetter }) => {

    const hiddenRef = useRef(null)
    const [ filename , setFilename ] = useState('')
    const [ localUrl , setLocalUrl ] = useState('')
    const [ error , setError ] = useState('')
    const [ progress , setProgress ] = useState()

    const clearError = ( ) => {
        setTimeout(()=>{setError('')},5000)
    }


    //click the invisible file input 
    const handleClick = ( event ) => { 
        hiddenRef.current.click();
    }

    const fileInputHandler = ( e ) => {
        e.preventDefault();
        const file = e.target.files[0];
        console.log('file is...')
        uploadFile( file )
    }
    
    const uploadFile = ( file ) => {
    //if there isnt a file then notify user and return  
    if( !file ) {
        setError('Please select a file to upload')
        clearError()
        return
    }

    setFilename( file.name )


    const storageRef = ref(cloudStorage, `collections/${file.name}`)
    const uploadTask = uploadBytesResumable(storageRef, file);
    
    uploadTask.on('state_changed', 
        (snapshot)=>{
        const prog = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes ) * 100
        );
        setProgress(prog);
        }, 
        (err) => { setError(err); clearError(); },
        ()=>{
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL)=>{
            console.log('file available at ', downloadURL)
            urlSetter( downloadURL )
            setLocalUrl( downloadURL )
            
        })
        })
    }

    return (
        <Wrapper>
            <h3> Choose An Image to Upload </h3>
            <span onClick = { handleClick }> 
                { progress < 100 && progress > 0 && <span>Upload {progress} % </span>}
                {
                    localUrl ? (
                        <>
                        <br/>
                        <div className='preview__container'>
                         
                         <img src={localUrl} alt={filename} /> 
                         <div className='overlay'>
                            <div className='content'>
                                Click to change the photo

                            </div>

                         </div> 

                     </div>
                     </>
                    ) 
                    : (<FaPlusCircle id='icon' size={32} /> )
                }
            </span>
            <input 
                type='file'
                ref={hiddenRef}
                onChange={ e => fileInputHandler(e) }
                style={{display: 'none'}}
            />
        </Wrapper>
    )
}

export default ImageUploader